export default __webpack_public_path__ + "static/media/pizza.a335e589.jpeg";